import { FC, useState } from "react";
import { useTranslation } from "i18n";
import { useLocalStorage } from "usehooks-ts";
import { AgenciesWithFilmmakers } from "component-library/src/components/Organisms/AppShell/navigation/helpers/getNavHeaderLinks";
import { AlertMessage } from "component-library/src/index";
import { IS_FILMMAKERS_LOG_IN_MODAL_HIDDEN } from "component-library/src/components/Organisms/AgenciesWithFilmmakersPopUp/AgenciesWithFilmmakersPopUp";
import "./SeveralAgenciesWithOneFilmmaker.scss";

interface Props {
  handleClose: () => void;
  handleSubmit: (agencyRefNumber: number, isHidden?: boolean) => Promise<void>;
  agenciesWithFilmmakers: AgenciesWithFilmmakers[];
  isError: boolean;
}

const SeveralAgenciesWithOneFilmmaker: FC<React.PropsWithChildren<Props>> = ({
  handleClose,
  handleSubmit,
  agenciesWithFilmmakers,
  isError,
}) => {
  const { t } = useTranslation();
  const [isHiddenLocalStorage] = useLocalStorage<boolean>(
    IS_FILMMAKERS_LOG_IN_MODAL_HIDDEN,
    false
  );
  const [isHidden, setIsHidden] = useState<boolean>(isHiddenLocalStorage);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleCheckboxChange = () => {
    setIsHidden(!isHidden);
  };

  return (
    <AlertMessage
      icon="notice"
      texts={{
        title: t("common:label.severalAgenciesWithOneFilmmaker.title"),
      }}
      buttons={[
        {
          name: t("common:button.severalAgenciesWithOneFilmmaker.continue"),
          click: async () => {
            setIsSubmitting(true);
            await handleSubmit(
              agenciesWithFilmmakers[0].AgencyRefNumber,
              isHidden
            );
            setIsSubmitting(false);
          },
          type: "primary",
          iconName: "icon-open-in-new-tab",
          loading: isSubmitting || isError,
        },
        {
          name: t("common:button.severalAgenciesWithOneFilmmaker.cancel"),
          click: handleClose,
          type: "secondary",
          ctaSecondaryDisabled: isSubmitting,
        },
      ]}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-4">
          <span className="text-base leading-5">
            {t("common:label.severalAgenciesWithOneFilmmaker.account")}
          </span>
          <span className="text-base leading-5">
            {t("common:label.severalAgenciesWithOneFilmmaker.agencies")}
          </span>
          <span className="text-base font-semibold leading-5">
            {agenciesWithFilmmakers[0].AgencyName}
          </span>
        </div>

        <div className="flex items-center justify-start gap-[14px]">
          <input
            type="checkbox"
            name={IS_FILMMAKERS_LOG_IN_MODAL_HIDDEN}
            id={IS_FILMMAKERS_LOG_IN_MODAL_HIDDEN}
            className="w-[25px] h-[25px] cursor-pointer"
            checked={isHidden}
            disabled={isError}
            onChange={handleCheckboxChange}
          />
          <label
            htmlFor={IS_FILMMAKERS_LOG_IN_MODAL_HIDDEN}
            className="text-base cursor-pointer select-none"
          >
            {t("common:label.severalAgenciesWithOneFilmmaker.dontShow")}
          </label>
        </div>
      </div>
    </AlertMessage>
  );
};

export default SeveralAgenciesWithOneFilmmaker;
